import router from '@/router';

const state = {
  isVideoLibraryDialogOpen: false
};

const getters = {};

const mutations = {
  setIsVideoLibraryDialogOpen(state, isOpen) {
    state.isVideoLibraryDialogOpen = isOpen;
  }
};

const actions = {
  openContentLabImport(context) {
    const currentRouteName = router.currentRoute.value.name;

    if (currentRouteName !== 'ContentLab') {
      router.push({ name: 'ContentLab', query: { redirect: '/import' } });
    } else {
      document.dispatchEvent(new CustomEvent('NavigateToContentLabImport'));
    }

    context.dispatch('toggleVideoLibraryDialog', false);
  },
  toggleVideoLibraryDialog(context, isOpen) {
    context.commit('setIsVideoLibraryDialogOpen', isOpen);
  },
  editVideoAssetInContentLab(context, { contentId, projectId, url }) {
    context.commit('setIsVideoLibraryDialogOpen', false);
    document.dispatchEvent(new CustomEvent('EditVideoAssetInContentLab', { detail: { contentId, projectId, url } }));
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
